import React from "react";
import { Box, Table, Sheet, Typography } from "@mui/joy";
import { PageTitle } from "../../../components";
import { useLocation } from "react-router-dom";
import { formatDate, thousandSeparator } from "../../../utils";
import { getStatusLabel } from "../../../constant";

function CreateItems(title: string, value: string | number) {
  return { title, value };
}

const TransactionDetailsPage = () => {
  const { state } = useLocation();
  const { transDetails } = state;

  const rows = [
    CreateItems(
      "Amount",
      `Tsh. ${thousandSeparator(transDetails.amount)}${
        transDetails.currency ? ` ${transDetails.currency}` : ""
      }`,
    ),
    CreateItems("Currency", transDetails.currency),
    CreateItems("Agent Code", transDetails.agent_code),
    CreateItems("Agent Name", transDetails.agent_name),
    CreateItems("Wakala Account", transDetails.wakala_account),
    CreateItems(
      "Transaction Date",
      formatDate(transDetails.trans_date),
    ),
    CreateItems(
      "Status",
      getStatusLabel(transDetails.status),
    ),
    CreateItems("Channel", transDetails.channel),
    CreateItems(
      "Transaction Type",
      {
        1: "Deposit",
        2: "Withdrawal",
        3: "Top up",
      }[transDetails.trans_type] ?? "Unknown",
    ),
    CreateItems("UUID", transDetails.uuid),
    CreateItems(
      "Transaction Reference",
      transDetails.transaction_reference,
    ),
    CreateItems("OpenPesa Reference", transDetails.op_reference),
    CreateItems("Customer Reference", transDetails.customer_reference),
    CreateItems(
      "Source Account",
      transDetails.source_account,
    ),
    CreateItems(
      "Source Account Name",
      transDetails.source_account_name,
    ),
    CreateItems("Source FSP", transDetails.source_account_fsp),
    CreateItems(
      "Destination Account",
      transDetails.destination_account,
    ),
    CreateItems(
      "Destination Account Name",
      transDetails.destination_account_name,
    ),
    CreateItems("Destination FSP", transDetails.destination_account_fsp),
    CreateItems("Depositor Contact", transDetails.depositor_contact),
    CreateItems("Deposited By", transDetails.deposited_by),
    CreateItems("Description", transDetails.description),
    CreateItems("Receipt ID", transDetails.receipt_id),
    CreateItems("Remarks", transDetails.remarks),
  ];

  return (
    <Box>
      <PageTitle title={`Transaction Details`} />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Box
          sx={{
            gap: 2,
            display: "flex",
            flexDirection: "column",
            width: { xs: "unset", md: "70%" },
          }}
        >
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              display: "flex",
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>
                    Transaction Details
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <b>{row.title}</b>
                    </td>
                    <td>
                      <Typography
                        level="body-sm"
                        sx={{ wordBreak: "break-word" }}
                      >
                        {row.value || "-"}
                      </Typography>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Sheet>
        </Box>
      </Box>
    </Box>
  );
};

export default TransactionDetailsPage;
